import { createI18n as i18n } from 'vue-i18n'
import * as validators from '@vuelidate/validators'

import en from '../lang/en.json'

const DEFAULT_LOCALE = 'en'

const createI18nMessage = (i18n) => {
  const { t } = i18n.global || i18n

  return validators.createI18nMessage({ t })
}

export const createI18n = (messages = { en }) => {
  const cache = { i18n: null }

  if (!cache.i18n) {
    cache.i18n = i18n({
      locale: DEFAULT_LOCALE,
      fallbackLocale: DEFAULT_LOCALE,
      messages,
      legacy: false
    })
  }

  const withI18nMessage = createI18nMessage(cache.i18n);

  return {
    i18n: cache.i18n,
    loadMessage: async (locale) => {
      try {
        if (Object.keys(cache.i18n.global.getLocaleMessage(locale)).length === 0) {
          const messages = await import('@/lang/' + locale)
          cache.i18n.global.setLocaleMessage(locale, messages)
        }

        if (cache.i18n.global.locale !== locale) {
          cache.i18n.global.locale = locale
        }
      } catch (e) {
        console.error(e)
      }
    },
    validators: {
      required: withI18nMessage(validators.required)
    }
  }
}
